import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-sand-50 grain">
      <nav className="sticky top-0 z-50 glass">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-serif text-2xl text-stone-900" data-testid="privacy-brand">
            Skin<span className="text-sage-400">sights</span>
          </Link>
          <Link to="/" className="text-sm text-stone-600 hover:text-stone-900">Home</Link>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-xs uppercase tracking-[0.2em] text-sage-500">Last updated · Feb 2026</p>
        <h1 className="font-serif text-5xl tracking-tight text-stone-900 mt-2">Privacy Policy</h1>

        <div className="prose prose-stone mt-8 max-w-none text-stone-700 leading-relaxed space-y-5">
          <p><strong>Skinsights is a personal wellness journal</strong>, not a medical device. It helps you log how your skin feels day-to-day. We don't sell your data. Ever.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">What we collect</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Account info: email, display name, hashed password</li>
            <li>Diary entries you create: photos, symptom ratings, notes, treatments, body sites</li>
            <li>POEM scores you complete</li>
            <li>Diagnosed conditions and treatment regimens you record</li>
          </ul>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">How we use it</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To show you your own journal — that's the entire purpose of the app</li>
            <li>To generate AI observations on your photos via Anthropic Claude (photos are sent to Anthropic for inference, not retained for training per their API terms)</li>
            <li>To produce the PDF report when you tap "Export PDF"</li>
          </ul>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">Photo storage</h2>
          <p>Photos are stored in a private object-storage bucket. Each photo can only be retrieved with your authenticated session — we use signed URLs with your auth token attached so the URL alone is useless without your account.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">Your rights</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Export</strong> — generate a full PDF of your data at any time (Dashboard → Export PDF)</li>
            <li><strong>Delete</strong> — Settings → Delete account permanently wipes entries, photos, POEM scores, and your user record</li>
            <li><strong>Access</strong> — email <a href="mailto:hello@skinsights.app" className="text-sage-500 underline">hello@skinsights.app</a> for a full data dump</li>
          </ul>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">What this app is NOT</h2>
          <p>Skinsights is not regulated as a medical device. The AI observations are informational only, not diagnostic. For any concerning skin change, please see a qualified dermatologist.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">Children</h2>
          <p>Not intended for users under 13. If a parent records on behalf of a child, the parent is responsible for the account.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">Contact</h2>
          <p>Questions? <a href="mailto:hello@skinsights.app" className="text-sage-500 underline">hello@skinsights.app</a></p>
        </div>
      </main>
    </div>
  );
}
